const IconMore = () => {
  return (
    <g data-testid="icon-more">
      <circle cx="4" cy="12" r="2.5" fill="currentColor" />
      <circle cx="12" cy="12" r="2.5" fill="currentColor" />
      <circle cx="20" cy="12" r="2.5" fill="currentColor" />
    </g>
  );
};

export default IconMore;
